//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
    value: { type: [String, Number], default: '' },
    label: { type: String, default: '' },
    type: { type: String, default: 'text' },
    width: { type: String, default: '' },
    suffix: { type: String, default: '' },
    halfOpacitySuffix: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    notZero: { type: Boolean, default: false },
    maxLength: { type: Number, default: null },
    placeholder: { type: String, default: ' ' },
    // Prop maxNumber will properly work only with v-mask="'ordinaryNumber'"
    maxNumber: { type: Number, default: null },
    minNumber: { type: Number, default: null },
    customRules: { type: Array, default: () => [] },
    // =====================================================================
  },

  data() {
    return {
      localValue: this.value,
    };
  },

  watch: {
    value(newValue) {
      this.localValue = newValue;
    },
  },

  computed: {
    style() {
      return {
        width: this.width,
      };
    },

    combinedRules() {
      return [...this.getValidationRules, ...this.customRules];
    },

    getValidationRules() {
      const rules = [];

      if (this.$props.required) {
        rules.push((value) => (value !== null && value !== undefined && value !== '') || this.$t('This field must be filled'));
      }

      if (this.$props.notZero) {
        rules.push((value) => value > 0 || this.$t('This field must be greater than 0'));
      }

      return rules;
    },
  },

  methods: {
    keydownHandler(event) {
      this.$emit('input', event.target.value);
      this.$emit('submit', event.target.value);
    },

    blurHandler(event) {
      this.$emit('blur', event.target.value);
    },

    changeHandler(event) {
      this.$emit('input', event.target.value.trim());
    },

    handleInput(newValue) {
      this.localValue = newValue;
      if (this.$props.maxNumber || this.$props.minNumber) this.validateAndSetValue();
      this.$emit('input', newValue);
    },

    validateAndSetValue() {
      const numericValue = Number(this.localValue);
      if (!Number.isNaN(numericValue)) {
        if (numericValue < this.$props.minNumber) {
          this.localValue = this.$props.minNumber;
        } else if (numericValue > this.$props.maxNumber) {
          this.localValue = this.$props.maxNumber;
        }
      }
      this.$emit('input', this.localValue);
    },
  },
};
